import { EmailEntity } from '../entities/email-entity';

export default class State {
  items: Array<EmailEntity> = [];
}
